import { useEffect, useState } from 'react';
import { Facebook, MapPin, Sparkles, Plug } from 'lucide-react';

/**
 * Social Media → ⚙ → Napojené účty. Jen stav napojení (Meta, Google, AI)
 * a konec tokenu Meta — tokeny a klíče se mění ve Správě → Integrace
 * (šifrovaně, jen superadmin). Revize Nastavení, 2026-10-12.
 */
const IKONY = { meta: Facebook, google: MapPin, ai: Sparkles };
const STAV = { ok: ['Napojeno', '#059669'], neuplne: ['Neúplné', '#EF4444'], nenapojeno: ['Nenapojeno', null] };

export default function NapojeneUcty({ isDark, onOtevritSpravu = null }) {
    const [data, setData] = useState(null);
    const [chyba, setChyba] = useState(null);
    useEffect(() => {
        fetch('/api/sprava/integrace/stav', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
            .then((r) => (r.ok ? r.json() : Promise.reject(r.status))).then(setData).catch(() => setChyba('Stav napojení se nepodařilo načíst.'));
    }, []);
    const tlumene = isDark ? 'rgba(255,255,255,0.45)' : 'var(--text-muted)';
    const cara = isDark ? 'rgba(255,255,255,0.07)' : 'var(--border-subtle)';
    if (chyba) return <p className="text-sm" style={{ color: '#EF4444' }}>{chyba}</p>;
    if (!data) return <p className="text-sm" style={{ color: tlumene }}>Načítám…</p>;
    const dni = data.meta_token_dni;
    return (
        <div>
            {data.integrace.map((i) => {
                const Ikona = IKONY[i.id] || Plug;
                const [text, barva] = STAV[i.stav] || STAV.nenapojeno;
                return (
                    <div key={i.id} className="flex items-center" style={{ gap: 12, minHeight: 56, borderBottom: `1px solid ${cara}` }}>
                        <Ikona size={17} style={{ color: tlumene, flexShrink: 0 }} />
                        <div className="flex-1 min-w-0">
                            <p className="font-semibold truncate" style={{ margin: 0, fontSize: 13.5, color: 'var(--text-primary)' }}>{i.nazev}</p>
                            <p className="truncate" style={{ margin: '2px 0 0', fontSize: 11.5, color: tlumene }}>{i.chybi?.length ? `Chybí: ${i.chybi.join(', ')}` : i.popis}</p>
                        </div>
                        <span style={{ fontSize: 12, fontWeight: 600, color: barva || tlumene }}>{text}</span>
                    </div>
                );
            })}
            {dni != null && (
                <p className="text-sm" style={{ margin: '12px 0 0', color: dni < 7 ? '#EF4444' : 'var(--text-primary)' }}>
                    {dni < 0 ? `Token Meta vypršel před ${-dni} dny — publikování na Facebook a Instagram nepoběží.` : `Token Meta platí ještě ${dni} dní.`}
                </p>
            )}
            <p className="text-xs" style={{ color: tlumene, margin: '12px 0 0' }}>
                Tokeny a klíče se zadávají ve Správě → Integrace (ukládají se šifrovaně).
                {onOtevritSpravu && (
                    <button type="button" onClick={onOtevritSpravu} className="font-semibold" style={{ marginLeft: 6, background: 'none', border: 'none', padding: 0, color: 'var(--text-primary)', cursor: 'pointer', textDecoration: 'underline' }}>
                        Otevřít
                    </button>
                )}
            </p>
        </div>
    );
}
